<section class="main-section-help-user-account" #idleAssistant>
  <div id="idleAssistant">
    <div class="main_section_headers" id="idleAssistantHeaders">
      <span>{{idleAssistantText}}</span>
    </div>
    <div class="ipos-help-create-account-body" id="idleAssistantAccountBody">
      <div id="idleAssistantSubTitle">
        <span i18n="@@ipos-help-idle-assistant.sub-title">After installing IPOS, install the Idle Assistant IPOS app from the Google* Play Store. 
          This application will help shoppers navigate back to IPOS after having closed the app.</span>
      </div>
      <div id="idleAssistantDesc" class="mt-3" i18n="@@ipos-help-idle-assistant.idle-assistant-starts-automatically-desc">Idle Assistant starts automatically when it detects the following:</div>
      <div class="mb-3" id="idleAssistantMsg">
        <ul>
          <li i18n="@@ipos-help-idle-assistant.its-been-a-minute.msg">IPOS has not been running for at least one minute.</li>
          <li i18n="@@ipos-help-idle-assistant.chromebook-cpu-has-not-exceeded.msg">The Chromebook* CPU has not exceeded 30% utilization for at least one minute.</li>
        </ul>
        <img class="ipos-help-idle-assistant-first-image" alt="idle_assistant_first">
      </div>
      <div class="ipos-help-create-account-desc" id="iposHelpAccountDesc">
        <div #sectionA class="oda-heading-style" id="iposHelpAccountDescODA">
          <div class="expand-view" id="iposExpandView">
            <span i18n="@@ipos-help-idle-assistant.title.section1">SECTION A: DOWNLOAD IDLE ASSISTANT IPOS APP FROM PLAY STORE</span>
            <div class="table_collapse_link collapsed arrow-icon" data-toggle="collapse"
              [attr.aria-expanded]="isSectionA" aria-controls="collapseOne" id="Section1">
              <img (click)="showDescription('sectionA')"
                class="margin-set accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section"
                [ngClass]="isSectionA?'transform-180':''" />
            </div>
          </div>
        </div>
        <div id="Section1" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div" id="collapseOne"
          data-parent="#Section1" #collapse="ngbCollapse" [(ngbCollapse)]="!isSectionA">
          <ol class="ipos-help-create-account-list mb-3">
            <li i18n="@@ipos-help-idle-assistant.section1.exit-ipos-to-desktop-desc">Exit IPOS to desktop by swiping up or down with three fingers.</li>
            <li i18n="@@ipos-help-idle-assistant.section1.navigate-google-play-desc">Navigate to the Google* Play Store or Click this LINK: <a class="btn-link"
                (click)="navigate()">{{storeLink}}</a></li>
            <img class="ipos-help-idle-assistant-google-store" alt="idle_assistant_second">
            <li i18n="@@ipos-help-idle-assistant.section1.accept-terms-desc">Accept the Terms of Service</li>
            <img class="ipos-help-idle-assistant-terms-of-service" alt="idle_assistant_third">
            <li i18n="@@ipos-help-idle-assistant.section1.type-idle-assistant-ipos-desc">Type “Idle Assistant IPOS” in the Google* Play Store search bar and click the icon.</li>
            <img class="ipos-help-idle-assistant-store-search" alt="idle_assistant_fourth">
          </ol>
        </div>
        <div #sectionB class="oda-heading-style" id="sectionB">
          <div class="expand-view" id="expandViewODA">
            <span i18n="@@ipos-help-idle-assistant.title.section2">SECTION B: INSTALL IDLE ASSISTANT IPOS APP</span>
            <div class="table_collapse_link collapsed arrow-icon" data-toggle="collapse"
              [attr.aria-expanded]="isSectionB" aria-controls="collapseOne" id="Section2">
              <img (click)="showDescription('sectionB')"
                class="margin-set accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section"
                [ngClass]="isSectionB?'transform-180':''" />
            </div>
          </div>
        </div>
        <div id="Section2" aria-labelledby="headingOne" class="collapse customContentToIpos-sub-div" id="collapseOne"
          data-parent="#Section2" #collapse="ngbCollapse" [(ngbCollapse)]="!isSectionB">
          <ol class="ipos-help-create-account-list mb-3">
            <li i18n="@@ipos-help-idle-assistant.section2.install-and-continue-desc">Install and Continue</li>
            <img class="ipos-help-idle-assistant-install" alt="idle_assistant_fifth">
            <img class="ipos-help-idle-assistant-click-to-continue" alt="idle_assistant_sixth">
            <li><span i18n="@@ipos-help-idle-assistant.section2.please-complete-steps-desc">Please complete these steps on your screen:</span>
              <ul class="on-screen-list-style">
                <li i18n="@@ipos-help-idle-assistant.section2.click-the-skip-button-desc">Click the <strong>Skip</strong> button</li>
                <li i18n="@@ipos-help-idle-assistant.section2.click-the-continue-button-desc">Click the <strong>Continue</strong> button</li>
              </ul>
            </li>
            <img class="ipos-help-idle-assistant-complele-setup" alt="idle_assistant_seventh">
            <img class="ipos-help-idle-assistant-open-app-store" alt="idle_assistant_eight">
            <li i18n="@@ipos-help-idle-assistant.section2.follow-these-instructions">Follow these instructions.</li>
            <img class="ipos-help-idle-assistant-prompt" alt="idle_assistant_ninth">
            <img class="ipos-help-idle-assistant-usage-access" alt="idle_assistant_tenth">
            <li i18n="@@ipos-help-idle-assistant.section2.click-toggle-button">Click the toggle button and exit to desktop.</li>
            <img class="ipos-help-idle-assistant-toggle-button" alt="idle_assistant_eleventh">
            <li i18n="@@ipos-help-idle-assistant.section2.ipos-installation-complete">The IPOS and Idle Assistant IPOS installation is COMPLETE. Launch IPOS from the desktop.</li>
            <img class="ipos-help-idle-assistant-taskbar-image" alt="idle_assistant_twelveth">
          </ol>
        </div>
      </div>
    </div>
  </div>
</section>